import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT_Mapper extends BaseFormMapper<CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT);

		return _formData;
	}

	MapValues(): Partial<CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT> {
		return {};
	}
}

const Mappings: CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page2[0]",
	exceptions: 'topmostSubform[0].Page2[0].INPUT3b[0]',
	signature: 'topmostSubform[0].Page2[0].INPUT2b[0]',
	solicitorFirmName: 'topmostSubform[0].Page2[0].INPUT1b[0]',
	// "5":"topmostSubform[0].Page1[0]",
	province2: 'topmostSubform[0].Page1[0].DDPROVINCE2[0]',
	province1: 'topmostSubform[0].Page1[0].DDPROVINCE1[0]',
	dateYear: 'topmostSubform[0].Page1[0].INPUT20[0]',
	dateMonth: 'topmostSubform[0].Page1[0].INPUT19[0]',
	dateDay: 'topmostSubform[0].Page1[0].INPUT18[0]',
	datedAt: 'topmostSubform[0].Page1[0].INPUT17[0]',
	enclosures: 'topmostSubform[0].Page1[0].INPUT16[0]',
	electronicallyRegisteredLand: 'topmostSubform[0].Page1[0].INPUT15[0]',
	optionSelected: 'topmostSubform[0].Page1[0].RadioButtonList2[0]',
	fireInsuranceAgent: 'topmostSubform[0].Page1[0].INPUT14[0]',
	fireInsurancePolicyNumber: 'topmostSubform[0].Page1[0].INPUT13[0]',
	fireInsuranceName: 'topmostSubform[0].Page1[0].INPUT12[0]',
	taxesPaidTo: 'topmostSubform[0].Page1[0].INPUT11[0]',
	collateralAmount: 'topmostSubform[0].Page1[0].INPUT10[0]',
	registrationDate: 'topmostSubform[0].Page1[0].INPUT9[0]',
	registryOffice: 'topmostSubform[0].Page1[0].INPUT8[0]',
	identificationParcel: 'topmostSubform[0].Page1[0].INPUT7[0]',
	mortgageDate: 'topmostSubform[0].Page1[0].INPUT6[0]',
	registrationNumber: 'topmostSubform[0].Page1[0].INPUT5[0]',
	electronicRegistration: 'topmostSubform[0].Page1[0].RadioButtonList1[0]',
	legalDescription: 'topmostSubform[0].Page1[0].INPUT4[0]',
	propertyAddress: 'topmostSubform[0].Page1[0].INPUT3[0]',
	mortgagor: 'topmostSubform[0].Page1[0].INPUT2[0]',
	borrowers: 'topmostSubform[0].Page1[0].BWRLGLNM_OR_COMPANYNAME[0]',
	cibcPlcReferenceNumber: 'topmostSubform[0].Page1[0].ID_PRET_CLIENT[0]',
	// "31":"topmostSubform[0].Page1[0].BARCODE[0]"
};
export interface CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT {
	cibcPlcReferenceNumber: string;
	borrowers: string;
	mortgagor: string;
	propertyAddress: string;
	legalDescription: string;

	electronicRegistration: string;
	registrationNumber: string;
	mortgageDate: string;

	identificationParcel: string;
	registryOffice: string;

	registrationDate: string;
	collateralAmount: string;
	taxesPaidTo: string;

	fireInsuranceName: string;
	fireInsurancePolicyNumber: string;
	fireInsuranceAgent: string;

	optionSelected: string;

	province1: string;
	province2: string;

	electronicallyRegisteredLand: string;

	enclosures: string;

	datedAt: string;
	dateDay: string;
	dateMonth: string;
	dateYear: string;

	solicitorFirmName: string;

	signature: string;

	exceptions: string;
}
